module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Devices_16"],"path":[{"$":{"d":"M0,0V12H8V9H2V2H14V4h2V0ZM9,5V16h7V5Zm4,10H12V14h1Zm2-2H10V7h5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Devices_16.svg
// module id = hUCg
// module chunks = 1